import { formatCurrency } from 'common/FormatUtilities';
import { Line, Text, TextContainer } from './styles';

interface IDeliveryFeeLine {
  deliveryDiscount?: number;
  deliveryFee: number;
}

export const DeliveryFeeLine = ({ deliveryFee }: IDeliveryFeeLine) => (
  <Line>
    <Text data-cy={'order-discount-text'}>Delivery Fee</Text>
    <TextContainer>
      {deliveryFee === 0 ? <Text>Free</Text> : <Text data-cy='delivery-value'>{formatCurrency(deliveryFee)}</Text>}
    </TextContainer>
  </Line>
);
